(function () {
	const SHIPPING_LIST = '#pf_t_shipping';
	const ECONOMY = 'Economy_free';
	const FREIGHT = 'Freight_free';
	const LOCAL_DELIVERY = 'LocalDelivery_free';
	const LOCAL_DELIVERY_CACHE = 'bm-free-local-delivery';

	window.BM_FREE_LOCAL_DELIVERY = {
		zip: null,
		eligible: false,
		ready: false
	};

	let processing = false;

	function getButton(value) {
		return document.querySelector(
			`${SHIPPING_LIST} [data-filter-value="${value}"]`
		);
	}

	function isSelected(button) {
		return button?.getAttribute('aria-checked') === 'true';
	}

	function waitForBoostRender(delay = 500) {
		return new Promise((resolve) => {
			setTimeout(resolve, delay);
		});
	}

	async function handleFreeShippingClick(event) {
		if (processing) return;

		event.preventDefault();
		event.stopImmediatePropagation();
		processing = true;

		try {
			let economy = getButton(ECONOMY);
			let freight = getButton(FREIGHT);
			if (!economy || !freight) return;

			const freeShippingSelected = isSelected(economy) || isSelected(freight);
			if (freeShippingSelected) {
				if (isSelected(economy)) {
					economy.dataset.allowBoostClick = 'true';
					economy.click();
					await waitForBoostRender();
				}
				freight = getButton(FREIGHT);
				if (freight && isSelected(freight)) {
					freight.click();
					await waitForBoostRender();
				}
			} else {
				economy.dataset.allowBoostClick = 'true';
				economy.click();
				await waitForBoostRender();
				freight = getButton(FREIGHT);
				if (freight && !isSelected(freight)) {
					freight.click();
					await waitForBoostRender();
				}
			}
		} finally {
			processing = false;
			setTimeout(initBoostShipping, 100);
		}
	}

	function interceptFreeShipping(event) {
		const button = event.currentTarget;
		if (button.dataset.allowBoostClick === 'true') {
			delete button.dataset.allowBoostClick;
			return;
		}
		handleFreeShippingClick(event);
	}

	function updateShippingRefineBy() {
		const localChip = document.querySelector('#localdelivery_free-clear-filter');
		const economyChip = document.querySelector('#economy_free-clear-filter');
		const freightChip = document.querySelector('#freight_free-clear-filter');

		if (localChip) {
			const value = localChip.querySelector('.boost-sd__refine-by-vertical-refine-by-value');
			if (value) {
				value.textContent = 'Free Local Delivery';
			}

			localChip.setAttribute( 'aria-label', 'Clear Shipping: Free Local Delivery' );
			localChip.dataset.shippingReady = 'true';
		}

		if (economyChip) {
			const value = economyChip.querySelector('.boost-sd__refine-by-vertical-refine-by-value');
			if (value) {
				value.textContent = 'Free Shipping';
			}

			economyChip.setAttribute( 'aria-label', 'Clear Shipping: Free Shipping' );
			economyChip.dataset.combinedFreeShipping = 'true';
			economyChip.dataset.shippingReady = 'true';
		}

		if (freightChip) {
			freightChip.style.setProperty('display','none','important');
			freightChip.setAttribute('aria-hidden','true');
		}
	}

	async function handleFreeShippingRefineClick(event) {
		const chip = event.target.closest('[data-combined-free-shipping="true"]');
		if (!chip || processing) return;

		event.preventDefault();
		event.stopImmediatePropagation();
		processing = true;

		try {
			let economy = getButton(ECONOMY);
			let freight = getButton(FREIGHT);

			if (economy && isSelected(economy)) {
				economy.dataset.allowBoostClick = 'true';
				economy.click();
				await waitForBoostRender();
			}

			freight = getButton(FREIGHT);
			if (freight && isSelected(freight)) {
				freight.click();
				await waitForBoostRender();
			}
		} finally {
			processing = false;
			setTimeout(() => {
				initBoostShipping();
				updateShippingRefineBy();
			}, 100);
		}
	}
	document.addEventListener('click', handleFreeShippingRefineClick, true);

	function publishLocalDeliveryEligibility(zip, eligible) {
		const result = { zip: zip || null, eligible: Boolean(eligible), ready: true };
		window.BM_FREE_LOCAL_DELIVERY = result;
		document.documentElement.setAttribute( 'data-free-local-delivery', result.eligible ? 'true' : 'false' );
		document.dispatchEvent( new CustomEvent('bm:free-local-delivery-ready', { detail: result }) );
		initBoostShipping();
	}

	async function initLocalDeliveryEligibility() {
		const allowedZips = Array.isArray( window.BM_FREE_LOCAL_DELIVERY_ZIPS ) ? window.BM_FREE_LOCAL_DELIVERY_ZIPS.map(String) : [];
		document.documentElement.setAttribute('data-free-local-delivery','false');

		try {
			const cached = sessionStorage.getItem(LOCAL_DELIVERY_CACHE);
			if (cached) {
				try {
					const parsed = JSON.parse(cached);
					if (parsed?.zip) {
						const zip = String(parsed.zip).trim();
						publishLocalDeliveryEligibility(zip, allowedZips.includes(zip));
						return;
					}
				} catch (error) {
					sessionStorage.removeItem(LOCAL_DELIVERY_CACHE);
				}
			}

			const response = await fetch('https://ipwho.is/');
			if (!response.ok) {
				throw new Error(`IP lookup failed: ${response.status}`);
			}

			const data = await response.json();
			if (data?.success !== true) {
				throw new Error('IP location lookup unsuccessful');
			}

			const zip = String(data?.postal || '').trim();
			if (!zip) {
				throw new Error('Postal code unavailable');
			}

			sessionStorage.setItem( LOCAL_DELIVERY_CACHE, JSON.stringify({ zip: zip }) );
			publishLocalDeliveryEligibility(zip, allowedZips.includes(zip));

		} catch (error) {
			console.error('[Free Local Delivery] Eligibility check failed:', error);
			publishLocalDeliveryEligibility(null, false);
		}
	}
	// function updateLocalDeliveryFilter() {
	// 	const localDelivery = getButton(LOCAL_DELIVERY);
	// 	if (!localDelivery) return;

	// 	const localDeliveryItem = localDelivery.closest('li');
	// 	if (!localDeliveryItem) return;

	// 	const eligibility = window.BM_FREE_LOCAL_DELIVERY;
	// 	if (!eligibility || eligibility.ready !== true || eligibility.eligible !== true) {
	// 		localDeliveryItem.style.setProperty('display','none','important');
	// 		localDeliveryItem.setAttribute('aria-hidden','true');
	// 		return;
	// 	}

	// 	localDeliveryItem.style.removeProperty('display');
	// 	localDeliveryItem.removeAttribute('aria-hidden');
	// }

	function updateLocalDeliveryFilter() {
		const localDelivery = getButton(LOCAL_DELIVERY);
		if (!localDelivery) return;

		const localDeliveryItem = localDelivery.closest('li');
		if (!localDeliveryItem) return;

		// TEMP: ZIP validation disabled for filter testing
		localDeliveryItem.style.removeProperty('display');
		localDeliveryItem.removeAttribute('aria-hidden');
	}


	let freeShippingCountController = null;
	let freeShippingCountTimer = null;
	let lastFreeShippingCount = null;
	let lastFreeShippingContext = null;

	function getFreeShippingContext() {
		const params = new URLSearchParams(window.location.search);
		
		params.delete('pf_t_shipping');
		params.delete('page');
		params.sort();

		return window.location.pathname + "?" + params.toString();
	}

	function scheduleFreeShippingCombinedCount() {
		const economy = getButton(ECONOMY);
		const amount = economy?.querySelector('[data-free-shipping-count]');
		const currentContext = getFreeShippingContext();
		if ( amount && lastFreeShippingCount !== null && lastFreeShippingContext === currentContext ) {
			amount.textContent = '(' + lastFreeShippingCount.toLocaleString() + ')';
		}

		clearTimeout(freeShippingCountTimer);
		freeShippingCountTimer = setTimeout(() => {
			loadFreeShippingCombinedCount();
		}, 150);
	}

	async function loadFreeShippingCombinedCount() {
		const economy = getButton(ECONOMY);
		const freight = getButton(FREIGHT);
		if (!economy || !freight) return;

		const amount = economy.querySelector('[data-free-shipping-count]');
		if (!amount) return;

		if (isSelected(economy) && isSelected(freight)) {
			updateFreeShippingCount();
			return;
		}

		if (freeShippingCountController) {
			freeShippingCountController.abort();
		}

		freeShippingCountController = new AbortController();

		try {
			const pageUrl = new URL(window.location.href);
			pageUrl.searchParams.delete('pf_t_shipping');
			pageUrl.searchParams.append("pf_t_shipping", ECONOMY);
			pageUrl.searchParams.append('pf_t_shipping',FREIGHT);

			const apiUrl = new URL('https://services.mybcapps.com/bc-sf-filter/search');

			const params = apiUrl.searchParams;
			params.set('_', 'pf');
			params.set('t', Date.now());
			params.set( 'shop', window.Shopify?.shop || 'staging-brandsmart.myshopify.com' );
			params.set('page', '1');
			params.set('limit', '24');
			params.set('sort', 'relevance');
			params.set('locale', 'en');
			params.set('event_type', 'init');
			params.set('pg', 'search_page');
			params.set('build_filter_tree', 'true');
			params.set('collection_scope', '0');
			params.set('filter', 'true');

			const q = pageUrl.searchParams.get('q');
			if (q) {
				params.set('q', q);
			}

			pageUrl.searchParams.forEach((value, key) => {
				if (!key.startsWith('pf_')) return;
				params.append(key + "[]", value);
			});

			params.set('sort_first', 'available');
			params.set('product_available', 'true');
			params.set('variant_available', 'true');

			const response = await fetch(
				apiUrl.toString(),
				{
					method: 'GET',
					mode: 'cors',
					credentials: 'omit',
					signal: freeShippingCountController.signal,
					headers: {
						accept: '*/*'
					}
				}
			);

			if (!response.ok) {
				throw new Error(`Boost count request failed: ${response.status}`);
			}

			const data = await response.json();
			const count = Number(data?.total_product);
			if (!Number.isFinite(count)) return;

			lastFreeShippingCount = count;
			lastFreeShippingContext = getFreeShippingContext();

			const currentEconomy = getButton(ECONOMY);
			const currentAmount = currentEconomy?.querySelector( '[data-free-shipping-count]' );
			if (!currentAmount) return;
			currentAmount.textContent = '(' + count.toLocaleString() + ')';

		} catch (error) {
			if (error.name === 'AbortError') return;
			console.error('[Free Shipping] Count request failed:', error );
		}
	}

	function updateFreeShippingCount() {
		const economy = getButton(ECONOMY);
		const freight = getButton(FREIGHT);
		if (!economy || !freight) return;

		const amount = economy.querySelector('[data-free-shipping-count]');
		if (!amount) return;

		if (isSelected(economy) && isSelected(freight)) {
			const resultCount = document.querySelector('.boost-sd__product-count');
			if (!resultCount) return;

			const match = resultCount.textContent.match(/[\d,]+/);
			if (!match) return;

			const count = Number(match[0].replace(/,/g, ''));
			if (!Number.isFinite(count)) return;

			lastFreeShippingCount = count;
			lastFreeShippingContext = getFreeShippingContext();
			amount.textContent = '(' + count.toLocaleString() + ')';
		}
	}

	function initBoostShipping() {
		const economy = getButton(ECONOMY);
		const freight = getButton(FREIGHT);

		updateShippingRefineBy();
		updateLocalDeliveryFilter();

		if (!economy || !freight) return;

		const freightItem = freight.closest('li');

		if (freightItem) {
			freightItem.style.setProperty(
				'display',
				'none',
				'important'
			);

			freightItem.setAttribute(
				'aria-hidden',
				'true'
			);
		}

		updateFreeShippingCount();
		scheduleFreeShippingCombinedCount();

		if (economy.dataset.freeShippingBound === 'true') {
			return;
		}

		economy.dataset.freeShippingBound = 'true';
		economy.addEventListener('click',interceptFreeShipping,true);
	}

	function init() {
		initLocalDeliveryEligibility();
		initBoostShipping();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded',init);
	} else {
		init();
	}

	let observerScheduled = false;
	const observer = new MutationObserver(() => {
		if (observerScheduled) return;
		observerScheduled = true;
		requestAnimationFrame(() => {
			observerScheduled = false;
			initBoostShipping();
		});
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();